import { differenceInCalendarDays, startOfDay } from 'date-fns'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { IStore } from '../../../reducers'
import { getFilteringOptions } from '../../../reducers/bookingCalendar/selectors/filtering'
import { IFilterRoomsProps } from './FilterRooms'

function mapStateToProps() {
  const defaultFromDate = startOfDay(new Date())
  return (state: IStore): IFilterRoomsProps => {
    const { byDate, byPlace } = getFilteringOptions(state)

    return {
      initialValues: {
        dateFrom: byDate.from || defaultFromDate,
        dateTo: byDate.to,
        daysCount: differenceInCalendarDays(byDate.to, byDate.from) || 0,
        name: byPlace.name,
        numPersons: byPlace.persons,
      },
    }
  }
}

function bindDispatchToProps(dispatch: Dispatch) {
  return {}
}

export default connect(
  mapStateToProps(),
  bindDispatchToProps,
)
